import {Component} from '@angular/core';

@Component({
  selector: 'app-web-allocator-patient-crud',
  templateUrl: './patient-crud.component.html',
  styleUrls: ['./patient-crud.component.css']
})
export class PatientCrudComponent  {
}
